import axios from 'axios'
import store from '../store'

const state = {
  isFetching: false,
  isMore: false,
  creditTransactions: null
}

const actions = {
  LOAD_CREDIT_TRANSACTIONS: async ({commit}, queryData) => {
    try {
      if (queryData.page === 0) {
        commit('SET_CREDIT_TRANSACTIONS', [])
        commit('SET_IS_MORE', true)
      }
      commit('SET_IS_REQUEST', true)
      const url = 'credits/' + queryData.user_id + '/transactions'
      let {data} = await axios.get(url, {params: queryData})
      if (!data.error) {
        // Set total available credits
        store.commit('auth/UPDATE_USER_DATA', {key: 'totalCredits', value: data.total_credits})
        if (queryData.page > 0) {
          commit('ADD_CREDIT_TRANSACTIONS', data.credit_transactions)
        } else {
          commit('SET_CREDIT_TRANSACTIONS', data.credit_transactions)
        }
      } else {
        commit('SET_IS_REQUEST', false)
        commit('SET_IS_MORE', false)
      }
    } catch (e) {
      console.log('check error', e)
    }
  }
}

const mutations = {
  SET_IS_REQUEST: (state, data) => {
    state.isFetching = data
  },
  SET_IS_MORE: (state, data) => {
    state.isMore = data
  },
  SET_CREDIT_TRANSACTIONS: (state, creditTransactions) => {
    state.creditTransactions = creditTransactions
    state.isFetching = false
    state.isMore = true
  },
  ADD_CREDIT_TRANSACTIONS: (state, creditTransactions) => {
    state.isFetching = false
    state.isMore = true
    for (let key in creditTransactions) {
      state.creditTransactions.push(creditTransactions[key])
    }
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/credit.js